export default "__VITE_ASSET__DPtxP0mb__"